export function getAllActivityLogs(axiosPrivate: any) {
  return axiosPrivate.get('/activity-logs')
}

export function getRecordActivityLogs(
  axiosPrivate: any,
  tableName: string,
  recordId: number | string
) {
  return axiosPrivate.get('/activity-logs', {
    params: {
      table_name: tableName,
      record_id: recordId,
    },
  })
}
